import { Controller } from 'stimulus';

class Scroll extends Controller {

  initialize() {
    this.scroll = window.addEventListener('scroll', this.scrollEvents.bind(this), false);
    this.resize = window.addEventListener('resize', this.scrollEvents.bind(this), false);
    if (this.hasRepeaterTarget) {
      this.repeaterTargets.forEach((repeater) => {
        if (!repeater.getAttribute('data-background')) {
          repeater.setAttribute('data-background', window.getComputedStyle(repeater).getPropertyValue('--bg-color'));
        }
      });
    }
  }

  scrollEvents() {
    window.requestAnimationFrame(() => {
      this.navAndIndexHeight = document.getElementById('page-header').offsetHeight;
      this.heroScroll();
      this.footerScroll();
      if (this.hasRepeaterTarget) {
        this.navAndIndexHeight += document.querySelector('.section--repeaters-index').offsetHeight;
        this.repeaterScroll();
      }
    });
  }
  repeaterScroll() {
    this.repeaterTargets.forEach((repeater) => {
      const repeaterBottom = repeater.getBoundingClientRect().bottom;
      const repeaterTop = repeater.getBoundingClientRect().top;
      let repeaterRatio = 1.5 * (1 - repeaterBottom / window.innerHeight);
      let repeaterTransform = (window.innerHeight - repeaterBottom) / 2;
      if (repeaterTop < this.navAndIndexHeight && repeaterBottom > window.innerHeight / 1.5) {
        this.indexTarget.querySelector(`[data-controls="${repeater.id}"]`).classList.add('active')
      } else {
        this.indexTarget.querySelector(`[data-controls="${repeater.id}"]`).classList.remove('active');
      }
      if (repeaterBottom < window.innerHeight) {
        const bgRatio = (2 - repeaterBottom / window.innerHeight);
        const { style } = new Option();
        style.color = repeater.getAttribute('data-background');

        const [red, green, blue] = style.color.substr(style.color.indexOf('(')+1, style.color.length - 5).split(', ');
        const [r, g, b] = [parseInt(red)/bgRatio, parseInt(green)/bgRatio, parseInt(blue)/bgRatio].map(Math.round);
        const overlayColor = `rgb(${r}, ${g}, ${b})`;

        repeater.style.setProperty('--scroll-bg-overlay', repeaterRatio);
        repeater.style.setProperty('--bg-color', overlayColor);
        repeater.style.backgroundColor = 'var(--bg-color)';
        repeater.style.transform = `translate3d(0px, ${repeaterTransform}px, 0px)`;
      } else {
        repeater.style.setProperty('--scroll-bg-overlay', 0);
        repeater.style.removeProperty('--bg-color', 0);
        repeater.style.backgroundColor = '';
        repeater.style.transform = '';
      };
    });
  }
  heroScroll() {
    const heroHeight = this.heroTarget.offsetHeight;
    const heroSiblingOverlap = parseInt(window.getComputedStyle(this.heroTarget.nextElementSibling, false).getPropertyValue('margin-top'), 10);
    const heroHeightOverflow = heroHeight - heroSiblingOverlap > window.innerHeight ? heroHeight - heroSiblingOverlap - window.innerHeight : 0;

    const heroRatio = (heroHeight - window.pageYOffset + heroHeightOverflow) / heroHeight;
    let overlayRatio = (1 - (heroRatio**1.1));
    
    let heroTransform = (window.pageYOffset - heroHeightOverflow) / 2;



    if (heroRatio < 0) {
      heroTransform = window.innerHeight / 5;
    }


    if (heroHeightOverflow < window.pageYOffset) {
      this.heroTarget.style.setProperty('--scroll-bg-overlay', overlayRatio);
      this.heroTarget.style.transform = `translate3d(0px, ${heroTransform}px, 0px)`;
    } else this.heroTarget.style.transform = '';
  }

  footerScroll() {
      const distanceFromBottom = document.body.scrollHeight - window.innerHeight - window.pageYOffset,
            footerHeight = this.footerTarget.offsetHeight,
            bodyW = window.innerWidth;
      let footerRatio = (footerHeight - distanceFromBottom) / footerHeight;
      // Unclear why 55 is needed here. Without it, the footer goes up too much and leaves a blank space
      let footerTransform = (1 - footerRatio) * footerHeight / -5 + 55;

      if (footerTransform > 0) footerTransform = 0;

      // disable transform for mobile dimensions
      if(bodyW < 480) footerTransform = 0;

      if (footerRatio < 0) {
        footerRatio = 1;
      } else footerRatio = 1 - (footerRatio * 2);

      this.footerTarget.style.setProperty('--footer-bg-overlay', footerRatio);
      this.footerTarget.style.transform = `translate3d(0px, ${footerTransform}px, 0px)`;}
}

Scroll.targets = ['hero', 'footer', 'repeater', 'index'];

export default Scroll;
